import {DateTime} from 'acscp/store/dateTime';
import {FormattedDate, FormattedDateProps} from 'acscp/components/common/formattedDate';
import {InjectedIntlProps, injectIntl} from 'react-intl';
import React from 'react';

type FormattedDateRangeProps = FormattedDateProps & {
    rangeEndDate: DateTime | null
};

type FormattedDateRangeWithIntlOwnProps = FormattedDateRangeProps & InjectedIntlProps;

const FormattedDateRangeWithIntl: React.FC<FormattedDateRangeWithIntlOwnProps> = ({rangeEndDate, ...dateRangeProps}) => (
    <>
        <FormattedDate {...dateRangeProps}/>
        {rangeEndDate && <> - <FormattedDate {...dateRangeProps} date={rangeEndDate}/></>}
    </>
);

export const FormattedDateRange = injectIntl(FormattedDateRangeWithIntl);
